import { useTranslation } from 'react-i18next';

export const useProjectPhases = () => {
  const [t] = useTranslation('projects');

  const purchasePhasesMap = {
    1: t('steps.request', 'Förfrågan'),
    2: t('steps.evaluation', 'Utvärdering'),
    3: t('steps.negotiation', 'Förhandling'),
    4: t('steps.agreement', 'Avtal'),
  };

  const projectPhasesMap = {
    'Anbud/Kalkyl': t('projectPhase.AnbudKalkyl', 'Anbud/Kalkyl'),
    'Inköp/Produktion': t('projectPhase.InköpProduktion', 'Inköp/Produktion')
  };

  const purchasePhaseToName = (phase: number) => purchasePhasesMap[phase as keyof typeof purchasePhasesMap];
  const projectPhaseToName = (phase: string) => projectPhasesMap[phase as keyof typeof projectPhasesMap];

  return {
    purchasePhasesMap,
    projectPhasesMap,
    purchasePhaseToName,
    projectPhaseToName,
  };
};

